import dayjs from 'dayjs';

export interface IISODateProps {
  date: string | null | undefined | Date;
  format?: string;
  parseFormat?: string;
  /**
   * Se `true`, stampa la data nel formato 24:00 del giorno precedente (al posto di 00:00)
   */
  in24Hours?: boolean;
}

/**
 * Esclusivamente per la **visualizzazione**, procediamo a sottrarre un giorno
 * se l'ora di scadenza è a mezzanotte esatta.
 * Questo perché il token di dayjs "24" non modifica il giorno
 */
function getRenderableDate24Hours(date: dayjs.Dayjs) {
  if (date.format('kk:mm') === '24:00') {
    return date.subtract(1, 'day');
  }
  return date;
}

/**
 * Mostra una data nel formato locale.
 * Al momento è fissato in DD/MM/YYYY HH:mm:ss per via del formato.
 */
export function ISODate(props: IISODateProps) {
  if (!props.date) return null;

  const date = dayjs(props.date, props.parseFormat);

  if (props.in24Hours) {
    return (
      <span>
        {getRenderableDate24Hours(date).format(props.format ?? 'DD/MM/YYYY')}
      </span>
    );
  }

  return <span>{date.format(props.format ?? 'DD/MM/YYYY')}</span>;
}
